import { type UUID, DbMhtmlCapture, NameOfIndexForRecordingUuidThenNumericIndex, getRangeForAllRecordsWithRecordingUuid } from "./DatabaseTypes";
import type { EvidenceDatabase } from "./EvidenceDbStruct";

export class DbMhtmlCaptureTableReader {
	protected constructor(protected readonly db: EvidenceDatabase, public readonly recordingUuid: UUID) { }

	static #forRecordingUuid = new Map<UUID, DbMhtmlCaptureTableReader>();
	static forRecordingUuid = (db: EvidenceDatabase, recordingUuid: UUID) => DbMhtmlCaptureTableReader.#forRecordingUuid.get(recordingUuid) ?? (() => {
		const evidenceDbForRecording = new DbMhtmlCaptureTableReader(db, recordingUuid);
		DbMhtmlCaptureTableReader.#forRecordingUuid.set(recordingUuid, evidenceDbForRecording);
		return evidenceDbForRecording;
	})();

	forMhtmlCapturesAsync = async (callback: (event: DbMhtmlCapture) => Promise<void>) => {
		const db = await this.db;
		const indexes = await db.getAllKeysFromIndex("mhtmlCaptures", NameOfIndexForRecordingUuidThenNumericIndex, getRangeForAllRecordsWithRecordingUuid(this.recordingUuid));
		for await (const index of indexes) {
			const mhtmlCapture = await db.getFromIndex("mhtmlCaptures", NameOfIndexForRecordingUuidThenNumericIndex, [this.recordingUuid, index]);
			if (mhtmlCapture != null) {
				await callback(mhtmlCapture);
			}
		}
	};
	/**
	 * Retrieve all the page capture records (each with an MHTML blob) for the recording.
	 * @returns
	 */
	mhtmlCaptures = async () => await (await this.db).getAllFromIndex("mhtmlCaptures", NameOfIndexForRecordingUuidThenNumericIndex, getRangeForAllRecordsWithRecordingUuid(this.recordingUuid));


	static removeRecordingUuid = (recordingUuid: UUID) => DbMhtmlCaptureTableReader.#forRecordingUuid.delete(recordingUuid);
}
